module.exports = __webpack_public_path__ + "static/media/4.eabc142c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/benefit-list/4.jpg
// module id = 366
// module chunks = 0